import type { ServerResponse } from "@/http"
import type { IEventExtendPricing, IEventExtendPricingResponse } from "@/types"
import { axios } from "@/axios"

export async function getExtendEventPricing(eventVaultId?: number): Promise<IEventExtendPricing> {
  if (!eventVaultId) {
    throw new Error(
      "Missing `eventVaultId` when attempting to get extend event pricing. Please ensure `eventVaultId` is provided.",
    )
  }

  const endpoint = `api/event/${eventVaultId}/extendinfo`

  const response = (await axios.get<ServerResponse<IEventExtendPricingResponse>>(endpoint)).data

  return {
    gpxProductID: response.Data?.GPXProductID ?? 0,
    originalPrice: response.Data?.RegularPrice ?? 0,
    discountedPrice: response.Data?.SalePrice ?? 0,
    discountPercentage: response.Data?.Percentage ?? 0,
    isoCurrencyCode: response.Data?.ISOCurrencyCode ?? "",
    currencySymbol: response.Data?.CurrencySymbol ?? "",
    extendEventURL: response.Data?.ExtendURL ?? "",
  }
}
